export enum UserRolesEnum {
  // since the default value is the maximum allowable permission,
  //  add a new default value so we don't assume everyone is
  //  an admin if this isn't set.
  NotSet = -1,
  GlobalAdmin = 0,
  CompanyAdmin = 1,
  PharmacyAdmin = 2,
  PharmacyStaff = 3,
}
